/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReleasingInputs */

const en_releasing = /** @type {(inputs: ReleasingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasing...`)
};

const es_releasing = /** @type {(inputs: ReleasingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberando...`)
};

/**
* | output |
* | --- |
* | "Releasing..." |
*
* @param {ReleasingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const releasing = /** @type {((inputs?: ReleasingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReleasingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_releasing(inputs)
	return es_releasing(inputs)
});